module.exports = __webpack_public_path__ + "img/Deep Setting.233ddce8.png";